<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">A Detective from Small Town America</h1>
<ol class="toc" style="font-weight:bold"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#grandma-on-the-run">Grandma on the Run</a>
</li>
<li id="toc-li-7"><a href="#/text/ch005#good-movie-whos-watching-who">Good Movie! Who’s Watching Who?</a>
</li>
<li id="toc-li-10"><span href="#/text/ch006#guess-whos-coming-to-dinner" title="Link target outside of Sample">Guess Who’s Coming to dinner</span>
</li>
<li id="toc-li-13"><span href="#/text/ch007#hat-trick" title="Link target outside of Sample">Hat Trick</span>
</li>
<li id="toc-li-16"><span href="#/text/ch008#suspicious-person" title="Link target outside of Sample">Suspicious Person</span></li>
<li id="toc-li-17"><span href="#/text/ch009#jeffrey-j-frank-l." title="Link target outside of Sample">Jeffrey J (Frank L.)</span>
</li>
<li id="toc-li-22"><span href="#/text/ch010#is-there-a-doctor-in-the-house" title="Link target outside of Sample">Is There A Doctor In The House?</span>
</li>
<li id="toc-li-26"><span href="#/text/ch011#cedar-avenue-coin-collector" title="Link target outside of Sample">Cedar Avenue Coin Collector</span>
</li>
<li id="toc-li-31"><span href="#/text/ch012#man-shoots-at-gabe" title="Link target outside of Sample">Man Shoots at Gabe</span>
</li>
<li id="toc-li-34"><span href="#/text/ch013#dart-man" title="Link target outside of Sample">Dart Man</span></li>
<li id="toc-li-35"><span href="#/text/ch014#im-not-in-here" title="Link target outside of Sample">I’m Not in Here</span>
</li>
<li id="toc-li-38"><span href="#/text/ch015#are-you-ready-to-catch-some-fish" title="Link target outside of Sample">Are You Ready to Catch Some Fish?</span>
</li>
<li id="toc-li-44"><span href="#/text/ch016#lake-street" title="Link target outside of Sample">Lake Street</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7d5c272a